export const ParseMinimumLoad = value => Number(value);
